export default __webpack_public_path__ + "84a540373780d5350afddc06b5731ed5.svg";